import { isValidNumber } from '@/utils/isValidNumber';

export const INVALID_CHART_STYLE_RECID = 0;

export function isValidChartStyleRecid(recid: number | string, shouldConsiderSampleChartStyleRecidsValid: boolean) {
  // user-saved ChartStyle recid's must be non-negative because the sample ChartStyles have been assigned negative recid's
  return (
    isValidNumber(recid, { isRequiredToBeInteger: true, isRequiredToBeGreaterThanZero: !shouldConsiderSampleChartStyleRecidsValid }) &&
    Number(recid) !== INVALID_CHART_STYLE_RECID
  );
}
